import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { Main } from './components/Main'
import { Fetch } from '../../function/Fetch'
import { BridalPlanProps } from './BridalPlan.types'
import { useConfig } from '../../routes'
import { styleTheme } from '../../style/theme'
import { Header } from './components/Header'
import { ScrollButton } from './components/ScrollButton'

type ConfigType = {
  primaryColor: string
  viewTitle?: string
  className?: string
}

export const BridalPlan = () => {
  const config = useConfig() as ConfigType
  return <StyledPage primaryColor={config.primaryColor} viewTitle={config.viewTitle} />
}

export const Page: React.FC<ConfigType> = ({ className, primaryColor }) => {
  const { bridalFairPageKey, id } = useParams() as { bridalFairPageKey: string; id: string }
  const [plan, setPlan] = useState<BridalPlanProps>()
  const refresh = () => {
    ; (async () => {
      const url = `/customer/api/v1/bridal_fair_pages/${bridalFairPageKey}/bridal_plans/${id}`
      const res = await Fetch(url, 'GET', {})
      const json = (await res.json()) as { bridalPlan: BridalPlanProps }
      setPlan(json.bridalPlan)
    })()
  }

  useEffect(() => {
    refresh()
  }, [])

  return (
    <div className={className} id="targetTop">
      <Header plan={plan} />
      <Main plan={plan} primaryColor={primaryColor} />
      <div className="scroll_button_wrapper">
        <ScrollButton primaryColor={primaryColor} />
      </div>
    </div>
  )
}

const StyledPage = styled(Page)`
  max-width: 960px;
  margin: 0 auto;
  padding-bottom: 46px;

  > .scroll_button_wrapper {
    background-color: ${styleTheme.colors.white};
    border-top: 2px solid ${styleTheme.colors.gray.light};
    padding: 8px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-sizing: border-box;
  }

  @media screen and (max-width: 520px) {
    .tb {
      width: 100%;
    }

    .tb th {
      padding: 4px;
      font-size: 11px;
    }

    .tb td {
      padding: 4px;
      font-size: 11px;
    }
  }
  background-color: ${styleTheme.colors.white};
`
